import { render } from "./customerOrder.vue?vue&type=template&id=c81aaaa4&scoped=true"
import script from "./customerOrder.vue?vue&type=script&lang=js"
export * from "./customerOrder.vue?vue&type=script&lang=js"

import "./customerOrder.vue?vue&type=style&index=0&id=c81aaaa4&scoped=true&lang=less"
import "./customerOrder.vue?vue&type=style&index=1&id=c81aaaa4&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81aaaa4"]])

export default __exports__